import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export * from "./CSSEditorSection";
import PropertyButton from "./PropertyButton";
import PropertyLabel from "./PropertyLabel";
import PropertyRow from "./PropertyRow";
import { PropertyButtonV2 } from "../PropertyButtonV2";
export const CSSProperty = {
    Button: PropertyButton,
    Label: PropertyLabel,
    Row: PropertyRow
};
export const CSSPropertyEditor = ({ label, node, property, baseType, useValueEditingComponent, useValueEditingProps, useButtonEditingProps, styling: { $flipX } = {} })=>{
    const buttonProps = useButtonEditingProps({
        node,
        property
    });
    const _valueProps = useValueEditingProps({
        node,
        property
    });
    const { onClickValue, ...valueProps } = _valueProps;
    const type = valueProps.value?.type || baseType?.type || "css-string";
    const ValueEditingComponent = useValueEditingComponent({
        type: valueProps.value?.type || baseType?.type || "css-string",
        cssEnumHint: valueProps?.value?.type === "css-string" ? valueProps?.value?.cssEnumHint : baseType?.cssEnumHint
    });
    return /*#__PURE__*/ _jsx(CSSProperty.Row, {
        $flipX: $flipX,
        $size: "lg",
        children: $flipX ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(CSSProperty.Row.Options, {
                    readOnly: valueProps.readOnly,
                    onClick: onClickValue,
                    children: /*#__PURE__*/ _jsx(ValueEditingComponent, {
                        ...valueProps
                    })
                }),
                /*#__PURE__*/ _jsx(CSSProperty.Row.Label, {
                    children: /*#__PURE__*/ _jsx(PropertyButtonV2, {
                        label: label,
                        value: buttonProps.value,
                        isDynamic: buttonProps.isDynamic,
                        onOptionClick: buttonProps.openConditionalEditor,
                        onCommandClick: ()=>{
                            buttonProps.clearValue?.();
                        },
                        menuActions: buttonProps.dropdownOptions
                    })
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(CSSProperty.Row.Label, {
                    children: /*#__PURE__*/ _jsx(PropertyButtonV2, {
                        label: label,
                        value: buttonProps.value,
                        isDynamic: buttonProps.isDynamic,
                        onOptionClick: buttonProps.openConditionalEditor,
                        onCommandClick: ()=>{
                            buttonProps.clearValue?.();
                        },
                        menuActions: buttonProps.dropdownOptions
                    })
                }),
                /*#__PURE__*/ _jsx(CSSProperty.Row.Options, {
                    readOnly: valueProps.readOnly,
                    onClick: onClickValue,
                    children: /*#__PURE__*/ _jsx(ValueEditingComponent, {
                        ...valueProps
                    })
                })
            ]
        })
    });
};
export const CSSLiteralEditor = ({ label, node, property, baseType, useValueEditingComponent, useValueEditingProps })=>{
    const _valueProps = useValueEditingProps({
        node,
        property
    });
    const { onClickValue, ...valueProps } = _valueProps;
    const type = valueProps.value?.type || baseType?.type || "css-string";
    const ValueEditingComponent = useValueEditingComponent({
        type: valueProps.value?.type || baseType?.type || "css-string",
        cssEnumHint: valueProps?.value?.type === "css-string" ? valueProps?.value?.cssEnumHint : baseType?.cssEnumHint
    });
    return /*#__PURE__*/ _jsx(CSSProperty.Row, {
        $size: "lg",
        children: /*#__PURE__*/ _jsx(CSSProperty.Row.Options, {
            readOnly: valueProps.readOnly,
            onClick: onClickValue,
            children: /*#__PURE__*/ _jsx(ValueEditingComponent, {
                ...valueProps
            })
        })
    });
};
